import { Modal } from "PFComponents/modal";
import { PostUntilChangeReason, Template } from "PFTypes";
import { SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ExpiryDateChangeFields, ReasonsForm, useExpiryDateChangeForm } from "./expiry_date_change_fields";
import { PostUntilData } from "./expiry_date_modal.types";

type ExpiryDateModalProps = {
  title: string;
  reasonLabel: string;
  date?: string;
  reason?: PostUntilChangeReason | null;
  template: Template;
  onChange: (value: PostUntilData) => void;
  onClose: () => void;
};

export const ExpiryDateModal = ({
  title,
  reasonLabel,
  date,
  reason,
  template,
  onChange,
  onClose
}: ExpiryDateModalProps) => {
  const { t } = useTranslation("translation");
  const {
    control,
    handleSubmit,
    minDate,
    isReasonSelectorEnabled,
    isOtherReason,
    dropdownOptions,
    buildPostUntilData,
    shouldEnableSave
  } = useExpiryDateChangeForm({ date, reason, template });

  const handleSave: SubmitHandler<ReasonsForm> = (formData) => {
    onChange(buildPostUntilData(formData));
    onClose();
  };

  return (
    <Modal
      title={title}
      labelOK={t("save")}
      onOK={shouldEnableSave ? handleSubmit(handleSave) : undefined}
      onClose={onClose}
    >
      <ExpiryDateChangeFields
        control={control}
        reasonLabel={reasonLabel}
        minDate={minDate}
        isReasonSelectorEnabled={isReasonSelectorEnabled}
        isOtherReason={isOtherReason}
        dropdownOptions={dropdownOptions}
      />
    </Modal>
  );
};
